import styled from 'styled-components';

export const Calendar = styled.aside`
  width: 380px;
  margin-top: 1rem;

  @media(max-width: 767px) {
    width: 100%;
    margin-bottom: 1rem;
  }

  .DayPicker {
    background: var(--chakra-colors-blue-900);
    border-radius: 10px;
  }

  .DayPicker-wrapper {
    padding-bottom: 0;
  }

  .DayPicker,
  .DayPicker-Month {
    width: 100%;
  }

  .DayPicker-Month {
    border-collapse: separate;
    border-spacing: 8px;
    margin: 16px;
  }

  .DayPicker-Day {
    width: 40px;
    height: 40px;
  }

  .DayPicker-Day--available:not(.DayPicker-Day--outside) {
    background: var(--chakra-colors-blue-500);
    border-radius: 10px;
    color: #fff;
  }

  .DayPicker:not(.DayPicker--interactionDisabled)
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
    background: var(--chakra-colors-blue-300);
  }

  .DayPicker-Day--today {
    font-weight: normal;
  }

  .DayPicker-Day--disabled {
    color: #666360 !important;
    background: transparent !important;
  }

  .DayPicker-Day--selected {
    background: #50b683 !important;
    border-radius: 10px;
    color: #232129 !important;
  }
`
